'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { RoadmapDetailHeader } from './-components/RoadmapDetailHeader';

export const Route = createFileRoute(
  '/_stacktrace/product-roadmap/$roadmapId/_layout',
)({
  component: Layout,
});

function Layout() {
  return (
    <VStack className="min-h-0 flex-1">
      <RoadmapDetailHeader />
      <Outlet />
    </VStack>
  );
}
